var map = {
	"./icon-1.svg": "3cda",
	"./icon-11-green.svg": "1779",
	"./icon-11.svg": "aab9",
	"./icon-12.svg": "55c8",
	"./icon-14.svg": "c54b",
	"./icon-15.svg": "79fd",
	"./icon-16.svg": "4f18",
	"./icon-18.svg": "ec4e",
	"./icon-19.svg": "98de",
	"./icon-2.svg": "b55f",
	"./icon-20.svg": "98b1",
	"./icon-21.svg": "7653",
	"./icon-22-green.svg": "09d6",
	"./icon-22.svg": "5214",
	"./icon-23.svg": "70a6",
	"./icon-24.svg": "7152",
	"./icon-25.svg": "2111",
	"./icon-26.svg": "6364",
	"./icon-27.svg": "303a",
	"./icon-28.svg": "9ef6",
	"./icon-29.svg": "98e4",
	"./icon-3-green.svg": "378c",
	"./icon-3.svg": "efbc",
	"./icon-30.svg": "a616",
	"./icon-31-green.svg": "f16d",
	"./icon-31.svg": "f613",
	"./icon-35.svg": "12d4",
	"./icon-36.svg": "0651",
	"./icon-37.svg": "29bf",
	"./icon-38.svg": "0b6a",
	"./icon-4.svg": "4cbf",
	"./icon-40.svg": "7804",
	"./icon-41.svg": "4105",
	"./icon-43.svg": "c958",
	"./icon-44-green.svg": "d8e5",
	"./icon-44.svg": "8c15",
	"./icon-46.svg": "d4b6",
	"./icon-47.svg": "6815",
	"./icon-48.svg": "df5d",
	"./icon-5-green.svg": "5e13",
	"./icon-5.svg": "b298",
	"./icon-50.svg": "07da",
	"./icon-52.svg": "91cc",
	"./icon-6.svg": "a1fc",
	"./icon-67.svg": "6bf9",
	"./icon-68.svg": "d4f1",
	"./icon-69.svg": "0f71",
	"./icon-7.svg": "8f8b",
	"./icon-8.svg": "5a2f",
	"./icon-9.svg": "6092",
	"./icon-connect.svg": "d87f",
	"./icon-customer.svg": "9929",
	"./icon-lack-creativity.svg": "7213",
	"./icon-lego-ai.svg": "1cff",
	"./icon-lego-api.svg": "8f06",
	"./icon-lego-community.svg": "fd04",
	"./icon-lego-education.svg": "05ca",
	"./icon-lego-product.svg": "3c8a",
	"./icon-lego-solution.svg": "8e58",
	"./icon-misalignment.svg": "3c07",
	"./icon-miscommunication.svg": "fa4b",
	"./icon-requirement.svg": "b0e6",
	"./icon-team-knowledge-diff.svg": "ac43",
	"./phase-1.svg": "f07a",
	"./phase-2.svg": "3f87",
	"./phase-3.svg": "f567",
	"./phase-4.svg": "de8e",
	"./star.svg": "de8d",
	"./to_be_updated/icon-10.svg": "68a8",
	"./to_be_updated/icon-13.svg": "927c",
	"./to_be_updated/icon-17.svg": "591f",
	"./to_be_updated/icon-22.svg": "4697",
	"./to_be_updated/icon-31.svg": "c2fb",
	"./to_be_updated/icon-32.svg": "d899",
	"./to_be_updated/icon-33.svg": "79ea",
	"./to_be_updated/icon-34.svg": "f1d1",
	"./to_be_updated/icon-36.svg": "cd6e",
	"./to_be_updated/icon-39.svg": "c9be",
	"./to_be_updated/icon-40.svg": "720f",
	"./to_be_updated/icon-42.svg": "1316",
	"./to_be_updated/icon-45.svg": "f824",
	"./to_be_updated/icon-49.svg": "ed6e",
	"./to_be_updated/icon-51.svg": "103c",
	"./to_be_updated/icon-52.svg": "2abf",
	"./to_be_updated/icon-53.svg": "c823",
	"./to_be_updated/icon-54.svg": "76ad",
	"./to_be_updated/icon-55.svg": "c19b",
	"./to_be_updated/icon-56.svg": "27e4",
	"./to_be_updated/icon-57.svg": "239d",
	"./to_be_updated/icon-58.svg": "763e",
	"./to_be_updated/icon-59.svg": "ac59",
	"./to_be_updated/icon-60.svg": "b8c6",
	"./to_be_updated/icon-61.svg": "36a0",
	"./to_be_updated/icon-62.svg": "26a1",
	"./to_be_updated/icon-63.svg": "d550",
	"./to_be_updated/icon-64.svg": "a655",
	"./to_be_updated/icon-65.svg": "344c",
	"./to_be_updated/icon-66.svg": "ceec",
	"./to_be_updated/icon-white-1.svg": "cd35",
	"./to_be_updated/icon-white-10.svg": "23aa",
	"./to_be_updated/icon-white-11.svg": "3f30",
	"./to_be_updated/icon-white-12.svg": "69f4",
	"./to_be_updated/icon-white-13.svg": "eb69",
	"./to_be_updated/icon-white-14.svg": "4947",
	"./to_be_updated/icon-white-15.svg": "0912",
	"./to_be_updated/icon-white-16.svg": "3ca1",
	"./to_be_updated/icon-white-17.svg": "f945",
	"./to_be_updated/icon-white-18.svg": "1015",
	"./to_be_updated/icon-white-19.svg": "5aa0",
	"./to_be_updated/icon-white-2.svg": "fea1",
	"./to_be_updated/icon-white-20.svg": "1629",
	"./to_be_updated/icon-white-21.svg": "46a1",
	"./to_be_updated/icon-white-22.svg": "d7b1",
	"./to_be_updated/icon-white-23.svg": "6f03",
	"./to_be_updated/icon-white-24.svg": "54d9",
	"./to_be_updated/icon-white-25.svg": "4cc3",
	"./to_be_updated/icon-white-26.svg": "7dba",
	"./to_be_updated/icon-white-27.svg": "dc10",
	"./to_be_updated/icon-white-28.svg": "c90e",
	"./to_be_updated/icon-white-29.svg": "66e8",
	"./to_be_updated/icon-white-3.svg": "c357",
	"./to_be_updated/icon-white-30.svg": "068b",
	"./to_be_updated/icon-white-31.svg": "daf6",
	"./to_be_updated/icon-white-32.svg": "576f",
	"./to_be_updated/icon-white-33.svg": "99ec",
	"./to_be_updated/icon-white-34.svg": "1ff4",
	"./to_be_updated/icon-white-35.svg": "ba19",
	"./to_be_updated/icon-white-36.svg": "32fe",
	"./to_be_updated/icon-white-37.svg": "f472",
	"./to_be_updated/icon-white-38.svg": "8412",
	"./to_be_updated/icon-white-39.svg": "0697",
	"./to_be_updated/icon-white-4.svg": "ba9c",
	"./to_be_updated/icon-white-40.svg": "d7a2",
	"./to_be_updated/icon-white-41.svg": "e0e7",
	"./to_be_updated/icon-white-42.svg": "ba09",
	"./to_be_updated/icon-white-43.svg": "1944",
	"./to_be_updated/icon-white-44.svg": "e778",
	"./to_be_updated/icon-white-45.svg": "eb80",
	"./to_be_updated/icon-white-46.svg": "5235",
	"./to_be_updated/icon-white-47.svg": "8040",
	"./to_be_updated/icon-white-48.svg": "8933",
	"./to_be_updated/icon-white-49.svg": "1cac",
	"./to_be_updated/icon-white-5.svg": "d636",
	"./to_be_updated/icon-white-50.svg": "825c",
	"./to_be_updated/icon-white-51.svg": "45d2",
	"./to_be_updated/icon-white-52.svg": "b0bd",
	"./to_be_updated/icon-white-53.svg": "1e0c",
	"./to_be_updated/icon-white-54.svg": "7316",
	"./to_be_updated/icon-white-55.svg": "e534",
	"./to_be_updated/icon-white-56.svg": "4f9a",
	"./to_be_updated/icon-white-57.svg": "556f",
	"./to_be_updated/icon-white-58.svg": "4bab",
	"./to_be_updated/icon-white-59.svg": "3907",
	"./to_be_updated/icon-white-6.svg": "a192",
	"./to_be_updated/icon-white-60.svg": "74e0",
	"./to_be_updated/icon-white-61.svg": "fc7b",
	"./to_be_updated/icon-white-62.svg": "8500",
	"./to_be_updated/icon-white-63.svg": "9e85",
	"./to_be_updated/icon-white-64.svg": "fd2c",
	"./to_be_updated/icon-white-65.svg": "26f0",
	"./to_be_updated/icon-white-66.svg": "093f",
	"./to_be_updated/icon-white-67.svg": "eee4",
	"./to_be_updated/icon-white-7.svg": "b633",
	"./to_be_updated/icon-white-8.svg": "d3d1",
	"./to_be_updated/icon-white-9.svg": "34e1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "034b";